import {http} from "Services/Http/HttpClient";
import axios from "axios";
import {getAuth} from "../../Services/Security/AuthService";

export interface CreateMonthlyFeeModificationBody {
    year: number
    monthNumber: number
    childId: string
    description: string|null
    amount: number
}

export const createMonthlyFeeModification = async(body : CreateMonthlyFeeModificationBody) : Promise<unknown> => {
    return await http.post('month_fee_modifications', body)
}

export const updateMonthlyFeeModification = async(id:string, body : CreateMonthlyFeeModificationBody) : Promise<unknown> => {
    return await http.patch('month_fee_modifications/' + id, body)
}

export const deleteMonthlyFeeModifications = async(ids: string[]) : Promise<any> => {
    return http.delete('/month_fee_modifications', {
        data: {
            ids: ids
        }
    })
}

export const uploadMonthlyFeeModificationsFile = async (file: File) => {
    let data = new FormData()
    data.append('file', file)

    const fhttp = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "Content-type": "multipart/form-data;",
            "Authorization": getAuth()
        }
    })

    return fhttp.post(`/month_fee_modifications/import`, data)
}